import { carePhaseDefs } from '@shared';
import { WalkthroughMoment } from '../components/walkthrough-moment';
import { StepFrame } from '../components/step-frame';
import { useCareWalkthrough } from '../hooks/use-care-walkthrough';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import type { ConsumerStepProps } from './step-props';

export function WalkthroughStep({ clientId }: ConsumerStepProps) {
  const { goTo, back } = useConsumerFlow(clientId);
  const {
    moment,
    moments,
    position,
    momentCount,
    isLastMoment,
    showMoment,
    showNextMoment,
    showPreviousMoment,
    scenario,
  } = useCareWalkthrough(clientId);
  if (!moment || !scenario) return null;

  const phaseLabel = carePhaseDefs[moment.carePhase].label;

  return (
    <StepFrame
      step="walkthrough"
      title="Who pays at this point in care?"
      subtitle={`Moment ${position + 1} of ${momentCount} · ${phaseLabel}`}
      onBack={() => (position > 0 ? showPreviousMoment() : back('walkthrough-summary'))}
      help={
        <>
          <p>In a real claim, you contact the insurer, document qualifying care, and meet the policy’s waiting period.</p>
          <p>We assume care qualifies once you need help with two or more daily activities. Actual eligibility depends on policy terms.</p>
        </>
      }
      primary={{
        label: isLastMoment ? 'See the summary' : 'Next moment',
        onClick: isLastMoment ? () => goTo('walkthrough-summary') : showNextMoment,
      }}
      next={isLastMoment ? 'review the whole event.' : 'see what changes as care progresses.'}
    >
      <WalkthroughMoment moment={moment} moments={moments} position={position} onSelectMoment={showMoment} />
      <p className="text-muted-foreground text-sm">Family help is already reflected in the bill.</p>
    </StepFrame>
  );
}
